import { useState, useEffect } from 'react';

interface GroupEditTableProps {
    isOpen: boolean;
    onClose: () => void;
  }
  
  const GroupEditTable: React.FC<GroupEditTableProps> = ({ isOpen, onClose }) => {
    useEffect(() => {
      if (isOpen) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
  
      return () => {
        document.body.classList.remove('modal-open');
      };
    }, [isOpen]);
  
    const cancel = () => {
        onClose();
      }

      
    return (
      <>
        {isOpen && (
          <>
            <div className='modal fade show d-block' id='kt_modal_add_user' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              
              <div className='modal-dialog modal-dialog-centered mw-650px'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  {/* begin::Modal body */}
                  
                  <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
          >
            닫기
          </button>


                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
           

            </div>
            {/* begin::Modal Backdrop */}
            <div className='modal-backdrop fade show' ></div>
            {/* end::Modal Backdrop */}
          </>
        )}
      </>
    );
  };
  
  export { GroupEditTable };